import { useMemo } from 'react';
import { storeLayout } from '../router';

export type LabelOptions = {
  label: string;
  value: string;
  color: string;
};

export function useLabelOptions(): LabelOptions[] {
  const { store } = storeLayout.useRouteContext();

  return useMemo(() => {
    return store.labels
      .map((label) => ({
        label: label.label,
        value: String(label.id),
        color: label.color,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [store.labels]);
}
